export default __webpack_public_path__ + "static/media/rank-inact.bf80b297.svg";